import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Download, Sparkles, X, RefreshCw } from 'lucide-react';

const UpdateNotification = () => {
  const [updateInfo, setUpdateInfo] = useState(null);
  const [isDownloaded, setIsDownloaded] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!window.electronAPI) return;

    const cleanupAvailable = window.electronAPI.onUpdateAvailable((info) => {
      console.log('[UpdateNotification] Update available:', info);
      setUpdateInfo(info);
      setIsVisible(true);
    });

    const cleanupDownloaded = window.electronAPI.onUpdateDownloaded((info) => {
      console.log('[UpdateNotification] Update downloaded:', info);
      setUpdateInfo(info);
      setIsDownloaded(true);
      setIsVisible(true);
    });

    return () => {
      cleanupAvailable();
      cleanupDownloaded();
    };
  }, []);

  const handleInstall = () => {
    if (window.electronAPI) {
      window.electronAPI.installUpdate();
    }
  };

  const closeNotification = () => {
    setIsVisible(false);
  };

  if (!isVisible || !updateInfo) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 50, x: '-50%' }}
        animate={{ opacity: 1, y: 0, x: '-50%' }}
        exit={{ opacity: 0, y: 50, x: '-50%' }}
        style={{
          position: 'fixed',
          bottom: '24px',
          left: '50%',
          zIndex: 10001,
          background: 'rgba(10, 10, 15, 0.95)',
          backdropFilter: 'blur(12px)',
          border: '1px solid rgba(102, 126, 234, 0.4)',
          borderRadius: '16px',
          padding: '16px 24px',
          width: '420px',
          boxShadow: '0 12px 48px rgba(0, 0, 0, 0.6), 0 0 20px rgba(102, 126, 234, 0.2)',
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        <div style={{
          width: '40px',
          height: '40px',
          borderRadius: '10px',
          background: 'rgba(102, 126, 234, 0.15)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#667eea',
          flexShrink: 0,
        }}>
          {isDownloaded ? <RefreshCw className="animate-spin-slow" size={20} /> : <Download size={20} />}
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '2px' }}>
            <span style={{ color: 'white', fontWeight: '600', fontSize: '0.95rem' }}>
              {isDownloaded ? 'Update Ready' : 'Update Available'}
            </span>
            <Sparkles size={12} color="#00d4ff" />
          </div>
          <p style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '0.8rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            Version {updateInfo.version} is {isDownloaded ? 'ready to install' : 'available for download'}
          </p>
        </div>

        <div style={{ display: 'flex', gap: '8px' }}>
          {isDownloaded ? (
            <button
              onClick={handleInstall}
              style={{
                padding: '8px 16px',
                background: 'linear-gradient(135deg, #667eea, #00d4ff)',
                border: 'none',
                borderRadius: '8px',
                color: 'white',
                fontWeight: '600',
                fontSize: '0.8rem',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
              }}
            >
              Restart Now
            </button>
          ) : (
            <button
              onClick={closeNotification}
              style={{
                padding: '8px 16px',
                background: 'rgba(255, 255, 255, 0.08)',
                border: '1px solid rgba(102, 126, 234, 0.3)',
                borderRadius: '8px',
                color: 'white',
                fontSize: '0.8rem',
                cursor: 'pointer',
              }}
            >
              Later
            </button>
          )}
          
          <button
            onClick={closeNotification}
            style={{
              background: 'none',
              border: 'none',
              color: 'rgba(255, 255, 255, 0.3)',
              cursor: 'pointer',
              padding: '4px',
            }}
          >
            <X size={16} />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default UpdateNotification;
